var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c(
              "q-form",
              { ref: "editForm" },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "LBLBASEINFO" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: {
                                    url: _vm.saveUrl,
                                    isSubmit: _vm.isSave,
                                    param: _vm.data,
                                    mappingType: _vm.mappingType,
                                    label: "LBLSAVE",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveInfo,
                                    btnCallback: _vm.saveCallback,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "대기방지시설명",
                              name: "envAirMstPreventiveName",
                            },
                            model: {
                              value: _vm.data.envAirMstPreventiveName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data,
                                  "envAirMstPreventiveName",
                                  $$v
                                )
                              },
                              expression: "data.envAirMstPreventiveName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "방지시설일련번호",
                              name: "envAirMstPreventiveNo",
                            },
                            model: {
                              value: _vm.data.envAirMstPreventiveNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "envAirMstPreventiveNo", $$v)
                              },
                              expression: "data.envAirMstPreventiveNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "사내고유방지시설번호",
                              name: "envAirMstPreventiveNum",
                            },
                            model: {
                              value: _vm.data.envAirMstPreventiveNum,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data,
                                  "envAirMstPreventiveNum",
                                  $$v
                                )
                              },
                              expression: "data.envAirMstPreventiveNum",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: true,
                              type: "edit",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.data.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "plantCd", $$v)
                              },
                              expression: "data.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-dept", {
                            attrs: {
                              type: "edit",
                              label: "관리부서",
                              name: "deptCd",
                              isFirstValue: false,
                            },
                            model: {
                              value: _vm.data.deptCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deptCd", $$v)
                              },
                              expression: "data.deptCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-checkbox", {
                            attrs: {
                              editable: _vm.editable,
                              isFlag: true,
                              label: "LBLUSEFLAG",
                              name: "useFlag",
                            },
                            model: {
                              value: _vm.data.useFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "useFlag", $$v)
                              },
                              expression: "data.useFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBLLOCATION",
                              name: "location",
                            },
                            model: {
                              value: _vm.data.location,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "location", $$v)
                              },
                              expression: "data.location",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              suffix: "㎥/분",
                              type: "number",
                              required: true,
                              editable: _vm.editable,
                              label: "처리용량",
                              name: "handlingCapacity",
                            },
                            model: {
                              value: _vm.data.handlingCapacity,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "handlingCapacity", $$v)
                              },
                              expression: "data.handlingCapacity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              suffix: "㎥/분",
                              type: "number",
                              editable: _vm.editable,
                              label: "설계허가증상용량",
                              name: "permitCapacity",
                            },
                            model: {
                              value: _vm.data.permitCapacity,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "permitCapacity", $$v)
                              },
                              expression: "data.permitCapacity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "처리오염물질",
                              name: "handlingMaterial",
                            },
                            model: {
                              value: _vm.data.handlingMaterial,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "handlingMaterial", $$v)
                              },
                              expression: "data.handlingMaterial",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              type: "number",
                              editable: _vm.editable,
                              label: "처리농도",
                              name: "handlingConcentration",
                            },
                            model: {
                              value: _vm.data.handlingConcentration,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "handlingConcentration", $$v)
                              },
                              expression: "data.handlingConcentration",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              suffix: "%",
                              type: "number",
                              editable: _vm.editable,
                              label: "처리효율",
                              name: "handlingPercent",
                            },
                            model: {
                              value: _vm.data.handlingPercent,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "handlingPercent", $$v)
                              },
                              expression: "data.handlingPercent",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "적산전력계" },
                  },
                  [
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-checkbox", {
                            attrs: {
                              editable: _vm.editable,
                              isFlag: true,
                              label: "전력계부착여부",
                              name: "wattmeterFlag",
                            },
                            on: { input: _vm.changeWattmeterFlag },
                            model: {
                              value: _vm.data.wattmeterFlag,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "wattmeterFlag", $$v)
                              },
                              expression: "data.wattmeterFlag",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-select", {
                            attrs: {
                              required: _vm.data.wattmeterFlag == "Y",
                              editable:
                                _vm.editable && _vm.data.wattmeterFlag == "Y",
                              comboItems: _vm.wattmeterItems,
                              label: "적산전력계",
                              itemText: "envAirMstWattmeterName",
                              itemValue: "envAirMstWattmeterId",
                              name: "envAirMstWattmeterId",
                              type: "edit",
                            },
                            on: { input: _vm.changeWattmeter },
                            model: {
                              value: _vm.data.envAirMstWattmeterId,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "envAirMstWattmeterId", $$v)
                              },
                              expression: "data.envAirMstWattmeterId",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: false,
                              label: "적산전력계번호",
                              name: "envAirMstWattmeterNo",
                            },
                            model: {
                              value: _vm.data.envAirMstWattmeterNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "envAirMstWattmeterNo", $$v)
                              },
                              expression: "data.envAirMstWattmeterNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-2" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: false,
                              label: "배율",
                              type: "number",
                              name: "wattmeterMagnification",
                            },
                            model: {
                              value: _vm.data.wattmeterMagnification,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data,
                                  "wattmeterMagnification",
                                  $$v
                                )
                              },
                              expression: "data.wattmeterMagnification",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }